export default function loginReducer(isLogin, action) {
  switch (action.type) {
    // 这里的case其实是冗余，type其实是不用的，但为了以后扩展就先这样写，说不定还有其他的操作项，业务逻辑会不一样
    case 'login': {
      // console.log('login success')
      // console.log(isLogin)
      return action.isLogin
    }
    case 'logout': {
      // console.log('logout success')
      // console.log(isLogin)
      return action.isLogin
    }
    default: {
      throw Error('未知 action：' + action.type);
    }
  }
}